import { render, staticRenderFns } from "./customtable.vue?vue&type=template&id=c93034c0&"
import script from "./customtable.vue?vue&type=script&lang=js&"
export * from "./customtable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports